/** @format */
import { ModelPriceModifierGroup } from '@toucan/client/global/model';

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type GroupedPriceModifierGroups = {
    essential: ModelPriceModifierGroup[];
    extra: ModelPriceModifierGroup[];
};

export function getPriceModifierGroupsQueryKey(modelId: number | null) {
    return ['price-modifier-groups', modelId];
}

export function groupPriceModifierGroups(
    data: ModelPriceModifierGroup[]
): GroupedPriceModifierGroups {
    const essential: ModelPriceModifierGroup[] = [];
    const extra: ModelPriceModifierGroup[] = [];

    [...data]
        // eslint-disable-next-line id-length -- Legacy code: do not use as an example.
        .sort((a, b) => a.name.localeCompare(b.name))
        .forEach((item) => {
            const group = {
                ...item,
                // eslint-disable-next-line id-length -- Legacy code: do not use as an example.
                modifiers: [...item.modifiers].sort((a, b) =>
                    a.name.localeCompare(b.name)
                ),
            };

            if (item.isEssential) {
                essential.push(group);
            } else {
                extra.push(group);
            }
        });

    return { essential, extra };
}
